export interface Testimonial {
  name: string
  flag: string
  quote: string
  photo: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Emily R.',
    flag: '🇺🇸',
    quote:
      'Before this, I had notes everywhere and never knew what to review first. The biggest difference for me is having an actual path to follow.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/3865bf6b-bc19-4b5c-9826-95251a304aff.jpg',
  },
  {
    name: 'Sarah M.',
    flag: '🇨🇦',
    quote:
      'The comparison pages are incredibly useful. I kept mixing up similar concepts, and now I can review the differences in seconds.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/f80a031d-29e5-4dfc-8abf-84784f45b955.jpg',
  },
  {
    name: 'Olivia T.',
    flag: '🇬🇧',
    quote:
      'I love being able to do a quick 15-minute review instead of opening three different lecture decks and trying to figure out where to start.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/4cfe6c7c-4a78-4b3b-9130-eb089fb50293.jpg',
  },
  {
    name: 'Daniel K.',
    flag: '🇦🇺',
    quote:
      'It doesn\'t feel like another textbook. It feels like someone organized the important pieces of Prosthodontics into a system.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/1db35783-34aa-4e87-9675-ee905d06de07.jpg',
  },
  {
    name: 'Sophia P.',
    flag: '🇺🇸',
    quote:
      'The Master Map completely changed how I look at the subject. I finally feel like I can see how the topics fit together.',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/908ff6e2-7f28-4c90-8c1f-62991c4ac58d.jpg',
  },
]
